import React from "react";
import { useWTReportProductColumns } from "./useWTReportProductColumns";
import { AccessRights } from "../../../core/navigation/types";
import { TradeList } from "../../../data/trading/trades/types";
import { Table, TableDataProps } from "../../components/common/Table";
import { WeeklyTradingReportData } from "../../../data/reports/weeklyTrade/types";
import { useReportProductData } from "../../../data/reports/weeklyTrade/hooks/useReportProductData";
import { useWeeklyActions } from "./useWeeklyActions";

export interface WeeklyTradesTableProps {
  userAccessRights: AccessRights;
}

type WeeklyTradesTablePropsType = WeeklyTradesTableProps &
  TableDataProps<TradeList>;

const WTRProductTable: React.FunctionComponent<WeeklyTradesTablePropsType> = ({
  userAccessRights,
  ...tableProps
}) => {
  const columns = useWTReportProductColumns();
  const [data, load, reset] = useReportProductData();
  React.useEffect(() => reset, [reset]);

  return (
    <Table<WeeklyTradingReportData>
      {...tableProps}
      getData={load}
      immutableData={data}
      title=""
      columns={columns}
      //      actions={actions}
      options={{
        actionsColumnIndex: -1,
        search: false,
        toolbar: false,
      }}
    />
  );
};

export default WTRProductTable;
